import { render } from "./bottom.vue?vue&type=template&id=113c5aca&scoped=true"
import script from "./bottom.vue?vue&type=script&lang=js"
export * from "./bottom.vue?vue&type=script&lang=js"

import "./bottom.vue?vue&type=style&index=0&id=113c5aca&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-113c5aca"]])

export default __exports__